import script from "./MultiSelectOperate.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiSelectOperate.vue?vue&type=script&lang=ts&setup=true"

import "./MultiSelectOperate.vue?vue&type=style&index=0&id=97dc9b9a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97dc9b9a"]])

export default __exports__